import "core-js/modules/es.array.push.js";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
var baseUrl = process.env.VUE_APP_BASE_URL;
export default {
  name: 'jasbwg',
  data() {
    return {
      banners: [],
      datas: [],
      news: [],
      collections: [],
      exhibitions: [],
      edus: [],
      culturals: []
    };
  },
  methods: {
    toDetail(tid, title, cid, pageId) {
      this.$router.push(`/jasbwgTabs?id=${tid}&title=${title}&cid=${cid}${pageId ? `&pageId=${pageId}` : ''}`);
    },
    openDetail(data, index, appId, pageId) {
      this.$router.push(`/jasbwgDetail?cid=${data}&index=${index}${appId ? `&appIds=${appId}` : ''}${pageId ? `&pageId=${pageId}` : ''}`);
    },
    clickTab(n) {
      switch (n) {
        case 1:
          this.$router.push(`/jasbwgTabs?cid=5414590&title=吉博概况&id=1556675`);
          break;
        case 2:
          location.href = this.datas.find(item => {
            return item.id == 5565591;
          }).url;
          break;
        case 3:
          location.href = this.datas.find(item => {
            return item.id == 5565592;
          }).url;
          break;
        case 4:
          location.href = this.datas.find(item => {
            return item.id == 5414618;
          }).url;
          break;
        case 5:
          location.href = this.datas.find(item => {
            return item.id == 5622965;
          }).url;
          break;
      }
    },
    // 获取banner
    getBanner() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=1556674&pageId=300085&wfwfid=44672`).then(res => {
        this.banners = res.data.data.results.map(item => {
          return item.fields[0].value;
        });
        this.$nextTick(() => {
          new Swiper(this.$refs.swiperBanner, {
            pagination: {
              el: '#banner .pagination'
            },
            visibilityFullFit: true,
            loop: true
          });
          new Swiper(this.$refs.swiper1, {
            slidesPerView: 3.2,
            paginationClickable: true,
            //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
            spaceBetween: 0,
            //slide之间的距离（单位px）。
            freeMode: true,
            //默认为false，普通模式：slide滑动时只滑动一格，并自动贴合wrapper，设置为true则变为free模式，slide会根据惯性滑动且不会贴合。
            loop: false
          });
        });
      });
    },
    // 获取资讯
    getNewsList() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=1556670&pageId=300085&wfwfid=44672`).then(res => {
        this.news = res.data.data.results.map(item => {
          return {
            title: item.fields[1].value,
            time: item.fields[6].value
          };
        });
      });
    },
    getHeaderList() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/classifies?appIds=1556675&pageId=300085&wfwfid=44672`).then(res => {
        this.datas = res.data.data.classifies.map(item => {
          return {
            name: item.name,
            id: item.id,
            url: item.url,
            pid: item.pid
          };
        });
        console.log(this.datas);
      });
    },
    // 文创
    getWenchuangs() {
      let classifies = [{
        id: 5553833
      }];
      let data = encodeURIComponent(`${JSON.stringify(classifies)}`);
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=1556675&pageId=300085&wfwfid=44672&classifies=${data}`).then(res => {
        this.culturals = res.data.data.results.map(item => {
          return {
            name: item.fields[1].value,
            img: item.fields[0].value
          };
        });
      });
    },
    // 藏品鉴赏
    getCollectList() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=1556668&pageId=300085&wfwfid=44672`).then(res => {
        this.collections = res.data.data.results.map(item => {
          return {
            name: item.fields[1].value,
            img: item.fields[0].value
          };
        });
        this.$nextTick(() => {
          new Swiper(this.$refs.swiper2, {
            slidesPerView: 3.2,
            paginationClickable: true,
            spaceBetween: 0,
            freeMode: true,
            loop: false
          });
        });
        console.log(this.collections);
      });
    },
    // 展览列表
    getExhibitions() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=1556673&pageId=300085&wfwfid=44672`).then(res => {
        this.exhibitions = res.data.data.results.map(item => {
          return {
            name: item.fields[1].value,
            img: item.fields[0].value
          };
        });
        this.$nextTick(() => {
          new Swiper(this.$refs.swiper3, {
            slidesPerView: 1.3,
            spaceBetween: -50,
            loop: true
          });
        });
      });
    },
    // 教育
    getEdus() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=1556669&pageId=300085&wfwfid=44672`).then(res => {
        this.edus = res.data.data.results.map(item => {
          return {
            name: item.fields[1].value,
            img: item.fields[0].value
          };
        });
        this.$nextTick(() => {
          new Swiper(this.$refs.swiper4, {
            slidesPerView: 2.2,
            spaceBetween: 10,
            loop: false
          });
        });
      });
    }
  },
  mounted() {
    this.getBanner();
    this.getNewsList();
    this.getHeaderList();
    this.getCollectList();
    this.getExhibitions();
    this.getEdus();
    this.getWenchuangs();
  },
  created() {
    document.title = '吉安数字博物馆';
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'js/indexFlex.js';
    document.body.appendChild(script);
  },
  computed: {}
};